import React from 'react';
import {SearchField, DataGrid, RaymanUser, UserSize, FilterMenu, Text, SmartDateLabel, SmartTagText, IconMenu, Dialog} from 'components/core';
import {Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import {TemplatesCtx} from 'components/dataProviders/procedureTemplates';
import Singletons from 'controllers/Singletons';


const overrideStyle = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    toolbar: {
        padding: 24,
        height: 88,
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 88,
        '& .MuiGrid-item':
        {
            height: 40
        },
        '& .MuiTypography-root':
        {
            lineHeight: '40px'
        }
    },
    datagrid: {
        height: 'calc(100% - 88px)'
    },
    searchbox: {
        height: 40,
        width: 300
    }
  }), {name: "RaymanDataGrid"});

  function RowMenu({row, handleEdit})
  {
      const ctx = React.useContext(TemplatesCtx);
      const [open, setOpen] = React.useState(false);
      const [loading, setLoading] = React.useState(false);
  
      const handleClose = () => {
          setOpen(false);
      }
  
      const handleOpen = () => {
          setOpen(true);
      }
  
      const handleConfirm = () => {
          setLoading(true);
          ctx.funcs.delete(row.templateID).then(() => {
              setLoading(false);
              setOpen(false);
          });
      }
  
      let items = [
        {
            label: "Editar",
            onClick: () => handleEdit()
        },
        {
            label: "Borrar",
            onClick: () => handleOpen(),
            danger: true
        } 
      ];
      return <>
      <Dialog title="Eliminar plantilla" open={open} loading={loading} confirm="Eliminar" confirmColor="error" cancel="Cancelar" onConfirm={handleConfirm} onCancel={handleClose} onClose={handleClose}>
          ¿Está seguro? Una vez borrado no se podrá recuperar
        </Dialog>
      <IconMenu items={items} />
      </>
  }

const columns = {
    name: { 
        field: 'name',
        headerName: 'Nombre',
        flex: 1,
        // renderCell: (params) => {
    
        // }
    },
    lastModificationDatetime: {
        field: 'lastModificationDatetime',
        headerName: 'Ult. Modificación',
        width: 180,
        align: 'right',    
        headerAlign: 'right',
        renderCell: (params) => {
            return <>
            <SmartDateLabel unformatted datetime={params.value} />
            </>;
        }
    },
    lastModificationUser: {
        field: 'lastModificationUser',
        headerName: 'Modificado por',
        flex: 0.5,
        renderCell: (params) => {
            return <RaymanUser userID={params.value} size={UserSize.size32} />
        }
    },
    lastModificationJoined: {
        field: 'lastModificationJoined',
        headerName: 'Modificado por',
        flex: 0.5,
        renderCell: (params) => {
            return <RaymanUser userID={params.row.lastModificationUser} size={UserSize.size40} label={<SmartDateLabel unformatted datetime={params.row.lastModificationDatetime} />}/>
        }
    }
}

const collapsedColumns = [columns.name, columns.lastModificationJoined];
const extendedColumns = [columns.name, columns.lastModificationDatetime, columns.lastModificationUser];


export default function TemplatesList({onRowSelected = () => {}, collapsed = false, onEdit, dataset="open"})
{
    const classes = overrideStyle();
    const procsCtx = React.useContext(TemplatesCtx);
    const [data, setData] = React.useState(procsCtx.data.array);
    const [filters, setFilters] = React.useState({text: '', tags: []});
    const [gridColumns, setGridColumns] = React.useState([]);

    let searchTimeout = 0;

    const menuColumn = React.useMemo(() => ({
        field: 'menu',
        headerName: ' ',
        width: 40,
        align: 'center',
        disableClickEventBubbling: true,
        renderCell: (params) => {
            return <RowMenu row={params.row} handleEdit={() => onEdit(params.row.templateID)}/>
        }
    }),[onEdit]);


    React.useEffect(function filterData(){
        
        let tmpData = [...procsCtx.data.array];
        
        // apply filters
        tmpData = tmpData.filter((value) => {
            let result = true;
            if(filters.text) result &= value.name.toLowerCase().includes(filters.text);
            return result;
        });

        setData(tmpData);
    }, [procsCtx, dataset, filters]);

    React.useEffect(function handleColumns(){

        let gridCols = collapsed ? [...collapsedColumns] : [...extendedColumns];
        if(Singletons.userProfiles.expert || Singletons.userProfiles.admin) gridCols.push(menuColumn);
        if(dataset === "closed") gridCols.splice(gridCols.length - 2, 1, columns.closed);
        setGridColumns(gridCols);
    }, [dataset, collapsed, menuColumn]);

    const handleSelectRow = (row) =>
    {
        onRowSelected(row);
    }

    const handleSearchChange = (value) =>
    {
        if(searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
            let tmpFilters = {...filters};
            tmpFilters.text = value;
            if(tmpFilters.text !== filters.text) setFilters(tmpFilters);
        }, 300);
    }

    return <>
        <Grid container direction="row" justify="space-between" className={classes.toolbar}>
            <Grid item><SearchField className={classes.searchbox} onChange={handleSearchChange} /></Grid>
            <Grid item>
                <Grid container direction="row" justify="flex-end" spacing={2}>
                </Grid> 
            </Grid>
        </Grid>
        <DataGrid 
        rows={data}
        columns={gridColumns}
        onRowSelected = {(row) => handleSelectRow(row.data)}
        loading={procsCtx.loading}
        density="comfortable"
        className={classes.datagrid}
        />
    </>
}